

import { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../api/authServices";

export default function ChangePassword() {
  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
  });

  const [errors, setErrors] = useState({
    oldPassword: "",
    newPassword: "",
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validate = () => {
    let newErrors = {};

    if (!form.oldPassword.trim()) {
      newErrors.oldPassword =
        "Old password is required";
    }

    if (!form.newPassword.trim()) {
      newErrors.newPassword =
        "New password is required";
    } else if (form.newPassword.length < 6) {
      newErrors.newPassword =
        "Password must be at least 6 characters";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // inside handleSubmit()

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  try {
    setLoading(true);

    const response =
      await changePassword(form);

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: response.message,
      showConfirmButton: false,
      timer: 2000,
    });

    // delay redirect by 2 seconds
    setTimeout(() => {
      localStorage.removeItem("token");

      navigate("/signin");

      setForm({
        oldPassword: "",
        newPassword: "",
      });

      setErrors({
        oldPassword: "",
        newPassword: "",
      });
    }, 2000);

  } catch (error) {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "error",
      title:
        error?.response?.data?.message ||
        "Something went wrong",
      showConfirmButton: false,
      timer: 2000,
    });

  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-900 via-purple-800 to-pink-700 px-4 py-10">

      {/* Main Card */}
      <div className="w-full max-w-5xl bg-white rounded-3xl overflow-hidden shadow-2xl grid md:grid-cols-2">

        {/* Left Side */}
        <div className="hidden md:flex flex-col justify-center items-center bg-gradient-to-br from-blue-600 to-indigo-800 text-white p-10 relative">

          {/* Background Texture */}
          <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

          <div className="relative z-10 text-center">
            
            <h1 className="text-4xl font-bold mb-4">
              Secure Your Account
            </h1>

            <p className="text-lg text-blue-100 leading-relaxed">
              Update your password regularly to
              keep your account safe and secure.
            </p>

            {/* New Security Design */}
            <div className="mt-10 relative flex justify-center">

              {/* Glow Effect */}
              <div className="absolute w-56 h-56 bg-white/20 rounded-full blur-3xl"></div>

              {/* Security Card */}
              <div className="relative bg-white/10 backdrop-blur-lg border border-white/20 rounded-3xl p-8 shadow-2xl">

                <div className="flex items-center justify-center w-24 h-24 mx-auto rounded-full bg-white/20 border border-white/30">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-12 h-12 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 11c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1zm6-3V7a6 6 0 10-12 0v1a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2zm-8-1a4 4 0 118 0v1h-8V7z"
                    />
                  </svg>
                </div>

                <h3 className="text-xl font-semibold text-white text-center mt-5">
                  Strong Protection
                </h3>

                <p className="text-blue-100 text-sm text-center mt-2 leading-relaxed">
                  Keep your account secure by
                  updating your password regularly.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side Form */}
        <div className="p-8 md:p-12 bg-white">

          <div className="mb-8">
            <h2 className="text-3xl font-bold text-gray-800">
              Change Password
            </h2>

            <p className="text-gray-500 mt-2">
              Enter your old password and create
              a new one.
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            className="space-y-6"
          >

            {/* Old Password */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Old Password
              </label>

              <input
                type="password"
                name="oldPassword"
                value={form.oldPassword}
                onChange={handleChange}
                placeholder="Enter old password"
                className="w-full px-4 py-3 rounded-xl border border-gray-300 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
              />

              {errors.oldPassword && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.oldPassword}
                </p>
              )}
            </div>

            {/* New Password */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                New Password
              </label>

              <input
                type="password"
                name="newPassword"
                value={form.newPassword}
                onChange={handleChange}
                placeholder="Enter new password"
                className="w-full px-4 py-3 rounded-xl border border-gray-300 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition"
              />

              {errors.newPassword && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.newPassword}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold shadow-lg transition-all duration-300 disabled:opacity-50"
            >
              {loading
                ? "Updating..."
                : "Update Password"}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}